import * as React from 'react';
import { Link } from 'react-router-dom';

const Index = () => (
  <div className='application-form-wrap'>
    <h6>Section 2</h6>
    <h1>INDIVIDUAL PLAN HOLDERS</h1>
    List of plan holders will be here
    <Link className='button primary-button' to={{ pathname: '/application-form/new-planholder' }}>
        + Add
     </Link>
  </div>
);

export default Index;
